$(function () {

  function toggleHeaderLogo() {

    // .daruman_kv が存在する場合は hide を付与
    if ($('.daruman_kv').length) {
      $('.drmn_logo').addClass('hide');
    } else {
      $('.drmn_logo').removeClass('hide');
    }

    // 既存処理
    var scroll = $(window).scrollTop();
    var trigger = window.innerHeight * 0.5; // 50vh

    if (scroll > trigger) {
      $('.drmn_logo').addClass('show');
    } else {
      $('.drmn_logo').removeClass('show');
    }

  }

  $(window).on('scroll resize', toggleHeaderLogo);

  toggleHeaderLogo();

});


document.addEventListener('DOMContentLoaded', () => {

  const targets = document.querySelectorAll('.sa');
  if (!targets.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    targets.forEach(el => el.classList.add('show'));
    return;
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0,
    rootMargin: '0px 0px -25% 0px' //表示位置
  });

  targets.forEach(el => observer.observe(el));

});

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.sa-progress');
  if (!targets.length) return;

  const updateOpacity = () => {
    targets.forEach(el => {
      // クラスで開始位置を切り替え
      let start;
      if (el.classList.contains('at50')) {
        start = window.innerHeight * 0.5;
      } else {
        // デフォルト
        start = window.innerHeight * 0.85;
      }

      const end = 0;

      const rect = el.getBoundingClientRect();
      const top = rect.top;

      let progress = (start - top) / (start - end);

      // 0〜1にクランプ
      progress = Math.max(0, Math.min(1, progress));

      el.style.opacity = progress;
    });
  };

  updateOpacity();
  window.addEventListener('scroll', updateOpacity, { passive: true });
  window.addEventListener('resize', updateOpacity);
});
